import { render, staticRenderFns } from "./RegisterEmployer.vue?vue&type=template&id=48440bb8&scoped=true"
import script from "./RegisterEmployer.vue?vue&type=script&lang=js"
export * from "./RegisterEmployer.vue?vue&type=script&lang=js"
import style0 from "./RegisterEmployer.vue?vue&type=style&index=0&id=48440bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48440bb8",
  null
  
)

export default component.exports